module.exports = __webpack_public_path__ + "img/nav2.948decdb.svg";